import { OLButton } from "OLButton";
import { EmptyState } from "components/EmptyState/EmptyState";
import { ReactComponent as CodeSquare02Icon } from "components/Icons/code-square-02.svg";
import { OLTabs } from "components/Tabs/OLTabs";
import { FieldArray } from "formik";
import { useMessage } from "hooks/intl";
import { useState } from "react";
import { Product, ProductType } from "./Product";
import { useStyles } from "./styles";

interface Props {
  products?: ProductType[];
  errors?: any;
  setFieldError: (fiels: string, value?: string) => void;
}

export const Products = ({ products, errors, setFieldError }: Props) => {
  const { message } = useMessage();
  const [activeTab, setActiveTab] = useState(0);
  const classes = useStyles();
  const isAnyProductAdded = products && products.length > 0;

  return (
    <FieldArray
      name="transaction.items"
      render={(attributesArray) => {
        const activeProductDetails = products && products[activeTab];

        return isAnyProductAdded ? (
          <>
            <div className={classes.header}>
              <OLTabs
                value={activeTab.toString()}
                items={
                  products
                    ? products.map((_ele, idx) => ({
                        id: idx.toString(),
                        name: `${message({ id: "product" })} ${idx + 1}`,
                        isError: !!errors?.[idx],
                      }))
                    : []
                }
                onChange={(_e, id) => {
                  setFieldError(`transaction.items[${activeTab}]`, undefined);
                  setActiveTab(Number(id));
                }}
              />
              <div className={classes.buttonWrapper}>
                <OLButton
                  onClick={() => {
                    attributesArray.remove(activeTab);
                    setActiveTab(activeTab === 0 ? 0 : activeTab - 1);
                  }}
                  variant="outlined"
                  data-test-id="campaign-simulator-product-delete-product-button"
                >
                  {message({ id: "delete" })}
                </OLButton>

                <OLButton
                  onClick={() => {
                    attributesArray.push({});
                    setActiveTab(products.length);
                  }}
                  variant="contained"
                  data-test-id="campaign-simulator-product-add-product-button"
                  className={classes.addBtn}
                >
                  {message({ id: "addProduct" })}
                </OLButton>
              </div>
            </div>
            {activeProductDetails && (
              <Product
                index={activeTab}
                details={activeProductDetails}
                key={activeTab}
              />
            )}
          </>
        ) : (
          <EmptyState
            icon={<CodeSquare02Icon />}
            title={message({ id: "addFirstProduct" })}
            description={message({ id: "addProductToSimulatedCampaign" })}
            button={
              <OLButton
                color="primary"
                onClick={() => attributesArray.push({})}
                variant="contained"
                size="medium"
                data-test-id="add-product"
              >
                {message({ id: "addProduct" })}
              </OLButton>
            }
          />
        );
      }}
    />
  );
};
